import { HStack, RadioCard } from "@chakra-ui/react";

type Option = {
  label: string;
  value: string;
};

type Props = {
  name: string;
  options: Option[];
  value?: string;
  onBlur?: () => void;
  onChange: (value: null | string) => void;
};

export const RadioInput = ({
  name,
  options,
  value,
  onBlur,
  onChange,
}: Props) => {
  return (
    <RadioCard.Root
      align="center"
      justify="center"
      name={name}
      orientation="horizontal"
      value={value}
      w="full"
      onValueChange={({ value }) => onChange(value)}
    >
      <HStack align="stretch" bg="bg.subtle" borderRadius="xl" gap="2">
        {options.map((option) => (
          <RadioCard.Item
            key={option.value}
            _checked={{ bg: "bg", shadow: "sm" }}
            bg="transparent"
            borderColor="transparent"
            borderRadius="xl"
            cursor="pointer"
            value={option.value}
          >
            <RadioCard.ItemHiddenInput onBlur={onBlur} />
            <RadioCard.ItemControl py="2.5">
              <RadioCard.ItemText>{option.label}</RadioCard.ItemText>
            </RadioCard.ItemControl>
          </RadioCard.Item>
        ))}
      </HStack>
    </RadioCard.Root>
  );
};
